var React = require('react');

function House (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288,72,64,269.85V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.85ZM352,330.66A21.4,21.4,0,0,1,330.63,352H245.34A21.4,21.4,0,0,1,224,330.66V245.32A21.4,21.4,0,0,1,245.34,224h85.29A21.4,21.4,0,0,1,352,245.32Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M571.9,258.87l-21.41,23.81c-1.8,2-12.46,10.23-22.59,1.22L288,72,48.12,283.9c-9.3,8.37-19.81,1.9-22.59-1.2L4.12,258.9c-8.37-9.3-1.9-19.81,1.2-22.6l256-226C267.59,4.61,279.57,0,288,0s20.44,4.61,26.72,10.3L416,99.67V48a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16V184.44l58.69,51.83C573.79,239.06,580.23,249.54,571.9,258.87Z","className":"fa-primary","key":2})]);
}

House.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = House;

House.default = House;
